import { render } from "./NewBundleModal.vue?vue&type=template&id=55380dfa"
import script from "./NewBundleModal.vue?vue&type=script&lang=js"
export * from "./NewBundleModal.vue?vue&type=script&lang=js"

import "./NewBundleModal.vue?vue&type=style&index=0&id=55380dfa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__